<div class="checkbox-radio check-center mb-16" *ngFor="let address of addresses$ | async; let i = index">
    <input
        [id]="address.id"
        name="address"
        type="radio"
        [value]="address.id"
        [checked]="(selectedAddress$ | async)?.id === address.id"
        (change)="selectAddress(address)"
    />
    <label [for]="address.id">
        <div class="box3 p-16 border-1-grey">
            <div class="box3-content">
                <div class="text-l pb-8">{{ address.fullName }}</div>
                <div class="text-l c-dark-grey">{{ address.addressFormattedCheckout.addressNumberLine }}</div>
                <div *ngIf="address.addressFormattedCheckout.additionalInfo as additionalInfo" class="text-l c-dark-grey">
                    {{ additionalInfo }}
                </div>
                <div class="text-l c-dark-grey">{{ address.addressFormattedCheckout.zipCodeStateLine }}</div>
            </div>
            <div class="box3-top text-right">
                <a class="link-line title-s ttu" [routerLink]="[]" queryParamsHandling="preserve" (click)="editAddress(address)"
                    >{{ 'dev.general.edit' | translate }}
                </a>
            </div>
        </div>
        <i class="ico-radio"></i>
    </label>
</div>
<div class="row">
    <div class="col-xs-12">
        <div class="btn btn-secondary btn--full mb-16" (click)="editAddress(null)">
            {{ 'dev.checkout.shipping.addNewAddress' | translate }}
        </div>
    </div>
</div>
